import { hasFullVenueAdminAccess } from 'src/utils/adminAccess'
import { VENUE_ADMIN } from 'src/utils/roles'
import { getDisplayedVenueRole } from 'src/utils/venueRoleCapabilities'

/**
 * The signed-in person's role on the venue for Settings tabs.
 * OMS Admin, a brand admin on their own brand's venue and the Primary Owner
 * are Venue Admin (same as useUserRole); everyone else uses the role shown on
 * their user card.
 */
export const resolveSettingsCurrentUserRole = ({ account, venue, venueId }) => {
  if (!account || !venue) return VENUE_ADMIN
  if (hasFullVenueAdminAccess(account, venue)) return VENUE_ADMIN
  const venueAccountId =
    venue.account?._id || venue.account?.toString() || venue.account
  const currentAccountId = account._id || account._id?.toString()
  if (
    venueAccountId &&
    currentAccountId &&
    venueAccountId.toString() === currentAccountId.toString()
  ) {
    return VENUE_ADMIN
  }
  const currentUserInAdditionalUsers = venue?.additionalUsers?.find(
    u => (u._id || u._id?.toString()) === currentAccountId?.toString(),
  )
  if (currentUserInAdditionalUsers) {
    return getDisplayedVenueRole(currentUserInAdditionalUsers, venueId)
  }
  return getDisplayedVenueRole(account, venueId)
}
